// extracted by mini-css-extract-plugin
module.exports = {"termsOfService":"TermsOfService-module--terms-of-service--1RIOT"};